type NavigatorWithUAData = Navigator & {
  userAgentData?: { mobile?: boolean };
};

export const isMobileDevice = (): boolean =>
  window.matchMedia("(pointer: coarse)").matches ||
  (navigator as NavigatorWithUAData).userAgentData?.mobile === true;
